import { render, staticRenderFns } from "./CopytoModal.vue?vue&type=template&id=b10a90e4&scoped=true&"
import script from "./CopytoModal.vue?vue&type=script&lang=js&"
export * from "./CopytoModal.vue?vue&type=script&lang=js&"
import style0 from "./CopytoModal.vue?vue&type=style&index=0&id=b10a90e4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b10a90e4",
  null
  
)

export default component.exports